import React from 'react';

const DataBreakdown = ({ data }) => {
  if (!data || Array.isArray(data)) return null;

  const hasValidData = (arr) =>
    Array.isArray(arr) && arr.length > 0 && arr.some(item => item.total > 0);

  const Section = ({ title, items, colorClass }) => (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
      <div className={`${colorClass} px-4 py-1 text-white font-bold text-sm flex justify-between`}>
        <span>{title}</span>
        <span>₹{items?.reduce((a, b) => a + b.total, 0)?.toLocaleString() || 0}</span>
      </div>
      <div className="px-4 space-y-4 max-h-[400px] overflow-y-auto">
        {items.map((cat, idx) => (
          <div key={idx} className="border-b last:border-0 pb-1">
            <div className="flex justify-between items-center mb-1">
              <h4 className="font-bold text-gray-700 uppercase text-xs">{cat.categoryName}</h4>
              <span className="font-bold text-gray-900">₹{cat.total.toLocaleString()}</span>
            </div>
            <ul className="space-y-1 pl-3 border-l-2 border-gray-100">
              {cat.items.map((item, i) => (
                <li key={i} className="flex justify-between text-sm text-gray-500">
                  <span>{item.name}</span>
                  <span className="font-medium">₹{item.value.toLocaleString()}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );

  const sections = [
    { title: "Expenses", items: data.expenses, color: "bg-red-500" },
    { title: "Direct Expenses", items: data.directExpenses, color: "bg-orange-500" },
    { title: "Indirect Expenses", items: data.indirectExpenses, color: "bg-amber-500" },
    { title: "Incomes", items: data.incomes, color: "bg-emerald-500" },
    { title: "Direct Income", items: data.directIncome, color: "bg-green-600" },
    { title: "Indirect Income", items: data.indirectIncome, color: "bg-teal-600" },
    { title: "Sales A/C", items: data.salesAccount, color: "bg-blue-600" }
  ];

  const validSections = sections.filter(sec => hasValidData(sec.items));

  if (validSections.length === 0) {
    return (
      <div className="text-center py-20 bg-white rounded-2xl border border-dashed border-gray-200 text-gray-400">
        No breakdown data found for the selected period.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-2">
      {validSections.map((sec, idx) => (
        <Section 
          key={idx} 
          title={sec.title} 
          items={sec.items} 
          colorClass={sec.color} 
        />
      ))}
    </div>
  );
};

export default DataBreakdown;
